/*
 *
 * VetrinaDigitalePopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.vetrinaDigitale.submitPopup.title'
      defaultMessage='Richiedi Vetrina Digitale'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.vetrinaDigitale.submitPopup.description'
      defaultMessage='<b>Procedi</b> per attivare Vetrina Digitale su Nexi.it.  <br /> <br /> Scopri tutti i dettagli del servizio e inizia a creare il tuo e-commerce in pochi e semplici click. <br /> <br /> <b>Segui le istruzioni</b> riportate e <b>concludi l’attivazione.</b>'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.vetrinaDigitale.submitPopup.primaryButtonLabel'
      defaultMessage='continua'
    />
  )
}

export default formattedMessage
